import { Directive, HostListener, Input, Optional } from '@angular/core';
import { NgControl } from '@angular/forms';

@Directive({
  selector: '[digitOnly]',
  standalone: true
})
export class DigitOnlyDirective {

  @Input('digitOnly') enabled: boolean = false;
  constructor(@Optional() private control: NgControl) { }

  @HostListener('keydown', ['$event'])
  onKeyDown(event: KeyboardEvent) {
    if (!this.enabled) return;

    const allowedKeys = ['Backspace', 'Delete', 'Tab', 'Escape', 'Enter', 'ArrowLeft', 'ArrowRight'];
    if (allowedKeys.includes(event.key)) return;

    const isCtrlCmd = event.ctrlKey || event.metaKey;
    if (isCtrlCmd && ['a', 'c', 'v', 'x'].includes(event.key.toLowerCase())) return;

    if (!/^\d$/.test(event.key)) {
      event.preventDefault();
    }
  }

  @HostListener('input', ['$event'])
  onInput(event: Event) {
    if (!this.enabled) return;
    const input = event.target as HTMLInputElement;
    const stripped = input.value.replace(/[^0-9]/g, '');
    if (input.value !== stripped) {
      input.value = stripped;
      this.control?.control?.setValue(stripped);
    }
  }

  @HostListener('paste', ['$event'])
  onPaste(event: ClipboardEvent) {
    if (!this.enabled) return;
    event.preventDefault();
    const pasted = event.clipboardData?.getData('text/plain') ?? '';
    const sanitized = pasted.replace(/[^0-9]/g, '');
    const input = event.target as HTMLInputElement;
    const start = input.selectionStart ?? 0;
    const end = input.selectionEnd ?? 0;
    const newValue = input.value.slice(0, start) + sanitized + input.value.slice(end);
    input.value = newValue;
    input.setSelectionRange(start + sanitized.length, start + sanitized.length);
    this.control?.control?.setValue(newValue);
  }

  @HostListener('drop', ['$event'])
  onDrop(event: DragEvent) {
    if (!this.enabled) return;
    event.preventDefault();
    const dropped = event.dataTransfer?.getData('text/plain') ?? '';
    const sanitized = dropped.replace(/[^0-9]/g, '');
    const input = event.target as HTMLInputElement;
    const start = input.selectionStart ?? 0;
    const end = input.selectionEnd ?? 0;
    const newValue = input.value.slice(0, start) + sanitized + input.value.slice(end);
    input.value = newValue;
    input.setSelectionRange(start + sanitized.length, start + sanitized.length);
    this.control?.control?.setValue(newValue);
  }
}
